import { Routes } from '@angular/router';

export const strategicPlanmodulesRoutes: Routes = [
  { path: '', redirectTo: 'overview/dashboard', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'overview',
    data: {
      name: 'Plan Overview',
      icon: 'widgets',
      iconType: 'MAT',
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
        data: { isNotAMenuItem: true },
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('../strategic-plan-features/sp-dashboard/sp-dashboard').then((m) => m.SpDashboard),
        data: {
          name: 'Overview',
        },
      },
      {
        path: 'identity',
        loadComponent: () =>
          import('../strategic-plan-features/sp-mission-vision/sp-identity/sp-identity').then((m) => m.SpIdentity),
        data: {
          name: 'Vision & Mission',
        },
      },
      {
        path: 'situation-analysis',
        loadComponent: () =>
          import('../strategic-plan-features/sp-situation-analysis/sp-situation-analysis/sp-situation-analysis').then((m) => m.SpSituationAnalysis),
        data: {
          name: 'Situational Analysis',
        },
      },
    ],
  },
  {
    path: 'strategy-structure',
    data: {
      name: 'Strategy Structure',
      icon: 'account_tree',
      iconType: 'MAT',
    },
    children: [
      {
        path: '',
        redirectTo: 'objectives',
        pathMatch: 'full',
        data: { isNotAMenuItem: true },
      },
      {
        path: 'objectives',
        loadComponent: () =>
          import('../strategic-plan-features/sp-objectives/sp-objectives/sp-objectives').then((m) => m.SpObjectives),
        data: {
          name: 'Objectives',
        },
      },
      {
        path: 'objectives/:objectiveId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-objectives/sp-objective-view/sp-objective-view').then(
            (m) => m.SpObjectiveView,
          ),
        data: { isNotAMenuItem: true, name: 'Objective Details' },
      },
      {
        path: 'strategies',
        loadComponent: () =>
          import('../strategic-plan-features/sp-strategies/sp-strategies/sp-strategies').then((m) => m.SpStrategies),
        data: {
          isNotAMenuItem: true,
          name: 'Strategies',
        },
      },
      {
        path: 'strategies/:strategyId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-strategies/sp-strategy-view/sp-strategy-view').then(
            (m) => m.SpStrategyView,
          ),
        data: { isNotAMenuItem: true, name: 'Strategy Details' },
      },
      {
        path: 'targets',
        loadChildren: () =>
          import('../strategic-plan-features/sp-targets/sp-targets.routes').then((m) => m.SpTargetsRoutes),
        data: {
          isNotAMenuItem: true,
          name: 'Targets',
        },
      },
    ],
  },
  {
    path: 'monitoring',
    data: {
      name: 'Monitoring',
      icon: 'monitoring',
      iconType: 'MAT',
    },
    children: [
      {
        path: '',
        redirectTo: 'plan',
        pathMatch: 'full',
        data: { isNotAMenuItem: true },
      },
      {
        path: 'plan',
        loadComponent: () =>
          import('../strategic-plan-features/sp-monitoring/sp-monitoring').then((m) => m.SpMonitoring),
        data: { name: 'Monitoring Plan', mode: 'plan' },
      },
      {
        path: 'plan/:monitoringId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-monitoring/view-sp-monitoring/view-sp-monitoring').then(
            (m) => m.ViewSpMonitoring,
          ),
        data: { name: 'Monitoring Details', isNotAMenuItem: true },
      },
      {
        path: 'plan/view-monitored-department/:id',
        loadChildren: () =>
          import('../strategic-plan-features/view-monitored-department/monitored-department-routes').then((m) => m.MonitoredDepartmentRoutes),
        data: { isNotAMenuItem: true, name: 'Department Activities' },
      },
      {
        path: 'report',
        loadComponent: () =>
          import('../strategic-plan-features/sp-monitoring/monitoring-report/monitoring-report').then((m) => m.MonitoringReport),
        data: { name: 'Monitoring Report', mode: 'report' },
      },
      {
        path: 'report/:monitoringId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-monitoring/view-sp-monitoring/view-sp-monitoring').then(
            (m) => m.ViewSpMonitoring,
          ),
        data: { name: 'Monitoring Details', isNotAMenuItem: true },
      },
      {
        path: 'report/view-monitored-department/:id',
        loadChildren: () =>
          import('../strategic-plan-features/view-monitored-department/monitored-department-routes').then((m) => m.MonitoredDepartmentRoutes),
        data: { isNotAMenuItem: true, name: 'Department Activities' },
      },
    ],
  },
  {
    path: 'annual-plans',
    data: {
      name: 'MTEF Annual Plans',
      icon: 'event_note',
      iconType: 'MAT',
    },
    children: [
      {
        path: '',
        redirectTo: 'plan',
        pathMatch: 'full',
        data: { isNotAMenuItem: true },
      },
      {
        path: 'plan',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/sp-annual-plans').then((m) => m.SpAnnualPlans),
        data: { name: 'Annual Plan', mode: 'plan' },
      },
      {
        path: 'planned-reviews',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/planned-reviews/sp-planned-reviews').then((m) => m.SpPlannedReviews),
        data: { name: 'Planned Review' },
      },
      {
        path: 'planned-reviews/:id',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/planned-reviews/planned-review-details/planned-review-details').then((m) => m.PlannedReviewDetails),
        data: { name: 'Review Details', isNotAMenuItem: true },
      },
      {
        path: 'progress-reports',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/progress-reports/sp-progress-reports').then((m) => m.SpProgressReports),
        data: { name: 'Progress Report' },
      },
      {
        path: 'plan-details/:id',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/plan-details/plan-details/plan-details').then((m) => m.PlanDetails),
        data: { isNotAMenuItem: true, name: 'Plan Details' },
      },
      {
        path: 'plan-details/:id/activity/:activityId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/plan-details/view-activity/view-activity.component').then((m) => m.ViewActivityComponent),
        data: { isNotAMenuItem: true, name: 'Activity Details' },
      },
      {
        path: 'plan-details/:id/activity/:activityId/task/:taskId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-annual-plans/plan-details/view-task/view-task.component').then((m) => m.ViewTaskComponent),
        data: { isNotAMenuItem: true, name: 'Task Details' },
      },
    ],
  },
  // {
  //   path: 'me-plan',
  //   data: {
  //     name: 'M&E Plan',
  //     icon: 'document_scanner',
  //     iconType: 'MAT',
  //   },
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: 'monitoring-plan',
  //       pathMatch: 'full',
  //       data: { isNotAMenuItem: true },
  //     },
  //     {
  //       path: 'monitoring-plan',
  //       loadComponent: () =>
  //         import('../strategic-plan-features/sp-me-plan/sp-monitoring-plan/sp-monitoring-plan').then((m) => m.SpMonitoringPlan),
  //       data: {
  //         name: 'Monitoring Plan',
  //       },
  //     },
  //     {
  //       path: 'evaluation-plan',
  //       loadComponent: () =>
  //         import('../strategic-plan-features/sp-me-plan/sp-evaluation-plan/sp-evaluation-plan').then((m) => m.SpEvaluationPlan),
  //       data: {
  //         name: 'Evaluation Plan',
  //       },
  //     },
  //   ],
  // },

  {
    path: 'evaluation',
    data: {
      name: 'Evaluation',
      icon: 'fact_check',
      iconType: 'MAT',
    },
    children: [
      {
        path: '',
        redirectTo: 'plan',
        pathMatch: 'full',
        data: { isNotAMenuItem: true },
      },
      {
        path: 'plan',
        loadComponent: () =>
          import('../strategic-plan-features/sp-evaluation/sp-evaluation').then((m) => m.SpEvaluation),
        data: { name: 'Evaluation Plan', mode: 'plan' },
      },
      {
        path: 'plan/:evaluationId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-evaluation/view-sp-evaluation/view-sp-evaluation').then(
            (m) => m.ViewSpEvaluation,
          ),
        data: { name: 'Evaluation Details', isNotAMenuItem: true },
      },
      {
        path: 'report',
        loadComponent: () =>
          import('../strategic-plan-features/sp-evaluation/sp-evaluation').then((m) => m.SpEvaluation),
        data: { name: 'Evaluation Report', mode: 'report' },
      },
      {
        path: 'report/:evaluationId',
        loadComponent: () =>
          import('../strategic-plan-features/sp-evaluation/view-sp-evaluation/view-sp-evaluation').then(
            (m) => m.ViewSpEvaluation,
          ),
        data: { name: 'Evaluation Details', isNotAMenuItem: true },
      },
    ],
  },
  {
    path: 'reports',
    data: {
      name: 'Reports & Plans',
      icon: 'summarize',
      iconType: 'MAT',
    },
    children: [
      { path: '', redirectTo: 'hub', pathMatch: 'full', data: { isNotAMenuItem: true } },
      {
        path: 'hub',
        loadComponent: () =>
          import('../strategic-plan-features/sp-reports/sp-reports').then((m) => m.SpReports),
        data: {
          isNotAMenuItem: true,
        }
      },
      {
        path: 'other-charges-budget',
        loadComponent: () =>
          import('../../me-sector/reporting/other-charges-budget/other-charges-budget').then((m) => m.OtherChargesBudgetReport),
        data: {
          name: 'AAP For Other Charges Budget',
        }
      },
      {
        path: 'development-project',
        loadComponent: () =>
          import('../../me-sector/reporting/development-project/development-project').then((m) => m.DevelopmentProjectReport),
        data: {
          name: 'AAP For Development Projects Budget',
        }
      },
      {
        path: 'annual-me-matrix',
        loadComponent: () =>
          import('../../me-sector/reporting/annual-me-matrix/annual-me-matrix').then((m) => m.AnnualMeMatrixReport),
        data: {
          name: 'Annual M&E Plan matrix',
        }
      },
      {
        path: 'quarterly-performance',
        loadComponent: () =>
          import('../../me-sector/reporting/quarterly-performance/quarterly-performance').then((m) => m.QuarterlyPerformanceReport),
        data: {
          name: 'Quarterly Progress Report',
        }
      },
      {
        path: 'dynamic-quarterly',
        loadComponent: () =>
          import('../../me-sector/reporting/dynamic-quarterly/dynamic-quarterly').then((m) => m.DynamicQuarterlyReport),
        data: {
          name: 'Summary of Performance Report',
        }
      },
      {
        path: 'implementation-performance-contract',
        loadComponent: () =>
          import('../../me-sector/reporting/implementation-performance-contract/implementation-performance-contract').then((m) => m.ImplementationPerformanceContractReport),
        data: {
          name: 'Implementation Performance Contract Report',
        }
      },
      {
        path: 'other-charges-implementation',
        loadComponent: () =>
          import('../../me-sector/reporting/other-charges-implementation/other-charges-implementation').then((m) => m.OtherChargesImplementationReport),
        data: {
          name: 'Other Charges (OC) Implementation Report',
        }
      },
      {
        path: 'directorate-performance',
        loadComponent: () =>
          import('../../me-sector/reporting/directorate-performance/directorate-performance').then((m) => m.DirectoratePerformanceReport),
        data: {
          name: 'Directorate/Unit Monitoring Report',
        }
      },
      {
        path: 'action-plan-monitoring',
        loadComponent: () =>
          import('../../me-sector/reporting/action-plan-monitoring/action-plan-monitoring').then((m) => m.ActionPlanMonitoringReport),
        data: {
          name: 'Annual Action Plan Monitoring Report',
        }
      },
      // {
      //   path: 'institution-performance',
      //   loadComponent: () =>
      //     import('../../me-sector/reporting/institution-performance/institution-performance').then((m) => m.InstitutionPerformanceReport),
      //   data: {
      //     name: 'Institutional Performance Report',
      //   }
      // },
      {
        path: 'framework-sample',
        loadComponent: () =>
          import('../../me-sector/reporting/framework-sample/framework-sample').then((m) => m.FrameworkSampleReport),
        data: {
          name: 'Framework Report',
        }
      },
      {
        path: 'board-committee',
        loadComponent: () =>
          import('../../me-sector/reporting/board-committee/board-committee').then((m) => m.BoardCommitteeReport),
        data: {
          name: 'Board Committee Report',
        }
      }
    ]
  },

];
